var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5148_7424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1687 3.19995C11.7266 3.19995 11.3688 3.55776 11.3688 3.99995C11.3688 4.44214 11.7266 4.79995 12.1687 4.79995C12.6109 4.79995 12.9688 4.44214 12.9688 3.99995C12.9688 3.55776 12.6109 3.19995 12.1687 3.19995ZM12.1687 5.59995C11.7266 5.59995 11.3688 5.95776 11.3688 6.39995C11.3688 6.84214 11.7266 7.19995 12.1687 7.19995C12.6109 7.19995 12.9688 6.84214 12.9688 6.39995C12.9688 5.95776 12.6109 5.59995 12.1687 5.59995ZM12.0813 7.98745C11.6687 8.03276 11.3594 8.38589 11.3688 8.79995V15.675L9.93125 14.2375C9.78125 14.0796 9.57344 13.989 9.35625 13.9875C9.03125 13.9906 8.74063 14.189 8.62031 14.4906C8.49844 14.7921 8.57344 15.1359 8.80625 15.3625L11.5063 18.05C11.5172 18.0718 11.5297 18.0921 11.5437 18.1125L11.6062 18.1625C11.7766 18.3343 12.0141 18.4187 12.2547 18.3953C12.4953 18.3703 12.7109 18.239 12.8438 18.0375L15.5312 15.3625C15.7703 15.1703 15.8781 14.8593 15.8094 14.5609C15.7406 14.2609 15.5078 14.0281 15.2078 13.9593C14.9094 13.8906 14.5984 13.9984 14.4062 14.2375L12.9688 15.675V8.79995C12.9719 8.58276 12.8875 8.37495 12.7344 8.22183C12.5813 8.0687 12.3734 7.98433 12.1562 7.98745C12.1313 7.98589 12.1062 7.98589 12.0813 7.98745ZM2.96875 15.2V19.9625C2.96875 20.6359 3.53281 21.2 4.20625 21.2H20.1313C20.8047 21.2 21.3687 20.6359 21.3687 19.9625V15.2H19.7688V19.6H4.56875V15.2H2.96875Z",
    fill: "#080715"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5148_7424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.17188 2)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIc);
export default __webpack_public_path__ + "static/media/download-ic.d182aec35c2bf604d0b647d1fbda157e.svg";
export { ForwardRef as ReactComponent };